<section id="searchResult" class="component component--search search" [ngClass]="filterButton ?'is-filtering':''">
	<div class="search__input">
		<div class="wrapper navigation__search">
			<form [formGroup]="formGroup" (validSubmit)="onSearchSubmitPage()" class="d-flex">
				<div class="form-group col">
					<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g id="menu_search" transform="translate(-141.000000, -279.000000)" fill="#979797">
								<g transform="translate(14.000000, 104.000000)" id="search_menu">
									<g>
										<path d="M142.640371,188.518908 L138.813618,184.697278 C139.390821,183.750467 139.722966,182.638809 139.722966,181.449278 C139.722966,177.993954 136.724955,175 133.264574,175 C129.805003,175 127,177.801396 127,181.256922 C127,184.712448 129.998011,187.7062 133.457582,187.7062 C134.607937,187.7062 135.685382,187.395113 136.611742,186.854656 L140.45895,190.697119 C140.835448,191.073133 141.445865,191.073133 141.821959,190.697119 L142.77647,189.744442 C143.153373,189.368226 143.016869,188.894922 142.640371,188.518908 L142.640371,188.518908 Z M128.928262,181.256922 C128.928262,178.86451 130.870094,176.925176 133.264776,176.925176 C135.660674,176.925176 137.795109,179.056866 137.795109,181.449278 C137.795109,183.84169 135.853277,185.781024 133.457785,185.781024 C131.062697,185.781024 128.928262,183.649334 128.928262,181.256922 L128.928262,181.256922 Z" id="Search"></path>
									</g>
								</g>
							</g>
						</g>
					</svg>
					<input type="text" class="form-control" required formControlName="SearchText" placeholder="{{ shareddata.searchText }}" value="{{ shareddata.searchText }}" autofocus id="search-text" (change)="onSearchChange($event.target.value)">
					<input type="hidden" id="hidden-search-text" value="{{ shareddata.searchText }}">
					<bfv-messages></bfv-messages>
					<span class="invalid-feedback-error" *ngIf="validation_error_show">This field is required</span>
				</div>
				<button type="submit" class="btn btn-bluelight btn-circle" (click)="onSearchSubmitPage()"><span>Search</span> <i class="icon-arrow-right"></i></button>
			</form>
		</div>
	</div>
	<!-- <div class="filterButton__wrapper" *ngIf="filterButton">
		<span class="filterButton">
			<span class="loading__circle loading__circle-small" id="fitlerLoader"></span>
		</span>
	</div> -->
	<div class="search__results-wrapper" *ngIf="!filterButton">
		<div class="wrapper">
			<h1 class="search__title">
				<span *ngIf="!defaultSearchPage">{{ searchCount }} hits on <em>{{ shareddata.searchText }}</em> within </span>
				<span *ngIf="defaultSearchPage">Type the search text to search within </span>
				<div ngbDropdown class="d-inline-block search-over__filter">
					<button class="btn btn-primary btn-outline-primary btn-circle" ngbDropdownToggle id="breadcrumbDropdown"><b [innerHtml]="selectedSortOptions"></b><span><i class="icon-breadcrumb-bottom"></i></span></button>
					<div class="search-over__filter-fields" ngbDropdownMenu aria-labelledby="breadcrumbDropdown" *ngIf="searchDropDown">
						<ul>
							<li *ngFor="let scVal of searchDropDown">
								<a class="search-over__filter-head {{ scVal.class }}" href="javascript:void(0);" [innerHtml]="scVal.title | safe:'preamble'" (click)="onSearchSubmitByOptions( $event, scVal.id, scVal.page_type, scVal.title );" [attr.data-slug]="scVal.page_type" [attr.data-id]="scVal.id" [attr.data-title]="scVal.title"></a>
								<ul *ngIf="scVal.child">
									<li *ngFor="let scChild of scVal.child">
										<a class="{{ scChild.class }}" href="javascript:void(0);"  [innerHtml]="scChild.title | safe:'preamble'" (click)="onSearchSubmitByOptions( $event, scChild.id, scChild.content_type, scChild.title );" [attr.data-slug]="scChild.content_type" [attr.data-id]="scChild.id" [attr.data-title]="scChild.title"></a>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
			 	<span class="wrapper text-search-option schedule-list-view" *ngIf="scheduleSearchResult">
			 		phrase found in
					<div ngbDropdown class="d-inline-block search-over__filter">
						<button class="btn btn-primary btn-outline-primary btn-circle" ngbDropdownToggle id="breadcrumbDropdown"><b>{{ scheduleSearchOption }}</b><span><i class="icon-breadcrumb-bottom"></i></span></button>
						<div class="search-over__filter-fields" ngbDropdownMenu aria-labelledby="breadcrumbDropdown" *ngIf="searchDropDown">
							<ul>
								<li>
									<a href="javascript:void(0);" (click)="onSearchSubmitByScheduleOptions( $event, 'all' )" [class.current]="scheduleSearchOption == 'All'" >All</a>
								</li>
								<li>
									<a href="javascript:void(0);" (click)="onSearchSubmitByScheduleOptions( $event, 'title' )" [class.current]="scheduleSearchOption == 'Title'">Title</a>
								</li>
								<li>
									<a href="javascript:void(0);" (click)="onSearchSubmitByScheduleOptions( $event, 'convenor' )" [class.current]="scheduleSearchOption == 'Convenor'">Convenor</a>
								</li>
								<li>
									<a href="javascript:void(0);" (click)="onSearchSubmitByScheduleOptions( $event, 'description' )" [class.current]="scheduleSearchOption == 'Description'">Description</a>
								</li>
								<li>
									<a href="javascript:void(0);" (click)="onSearchSubmitByScheduleOptions( $event, 'speakers' )" [class.current]="scheduleSearchOption == 'Speakers'">Speakers</a>
								</li>
							</ul>
						</div>
					</div>
				</span>
			</h1>
			<div *ngIf="!scheduleSearchResult">
				<div *ngIf="searchData">
					<div class="search__results-repeater" *ngFor="let sVal of searchData">
						<div class="wrapper">
							<a class="search__results" routerLink="{{ 'Programme' == sVal.type || 'Exhibition' == sVal.type || 'Networking' == sVal.type || 'Session' == sVal.type ? '/event/' : 'Newsfeed' == sVal.type ? '/community/feed/' : 'Covening organization' == sVal.type || 'Organization' == sVal.type ? '/community/organization/' : 'Participant' == sVal.type || 'Speaker' == sVal.type ? '/community/participant/' : 'news' == sVal.type ? '/' : '' }}{{ 'Newsfeed' != sVal.type ? sVal.slug : '' }}">
								<span class="post-type" *ngIf="sVal.type" [innerHtml]="sVal.type"></span>
								<h3 class="search__results-title" [innerHtml]="highlight_search_text( sVal.title | titlecase )" *ngIf="sVal.title"></h3>
								<div class="search__results-text" [innerHtml]="highlight_search_text( sVal.description ) | truncatetext: 40 | safe:'preamble'" *ngIf="sVal.description"></div>
							</a>
						</div>
					</div>
				</div>
				<div *ngIf="searchOrg">
					<div class="search__results-repeater" *ngFor="let sVal of searchOrg">
						<div class="wrapper">
							<a class="search__results" routerLink="//community/organization/{{ sVal.slug }}">
								<h3 class="search__results-title" [innerHtml]="highlight_search_text( sVal.name )" *ngIf="sVal.name"></h3>
								<div class="search__results-text" [innerHtml]="highlight_search_text( sVal.description ) | truncatetext: 40 | safe:'preamble'" *ngIf="sVal.description"></div>
							</a>
						</div>
					</div>
				</div>				
			</div>
		</div>
		<div class="schedule-search-result" *ngIf="scheduleSearchResult">
			<div class="schedule__events schedule__events-list-view" id="schedule__events">
				<div class="events">
					<div class="events__details">
						<div class="events__wrapper">
							<div class="grid-sizer"></div>
							<div class="items events__repeater" *ngFor="let sVal of searchData">
								<div class="wrapper">
									<div class="events__list">
										<div class="events__message"></div>
										<div class="events__text {{ ( sVal.hasConclusion == true ) ? 'events__concluded' : '' }}" style="">
											<div class="events__text-wrapper">
												<a class="{{ ( sVal.hasConclusion == true ) ? 'events__concluded' : '' }} events__link" routerLink="/event/{{sVal.slug}}" attr.data-slug="{{sVal.slug}}">
													<div class="maxed-width">
														<span class="label label-primary" *ngIf="sVal.hasConclusion == true">
															<i class="icon-conclusion"></i>
														</span>
														<h3 [innerHtml]="highlight_search_text( sVal.title )" *ngIf="sVal.title"></h3>
														<div class="orgafter org">
															<span *ngFor="let cVal of sVal.Convenors;last as isLast" [innerHtml]="highlight_search_text( cVal.name, 'convenor', isLast )"></span>
														</div>
														<div class="events__mobile-info">
															<span class="icon_wrapper"><i class="icon-clock"></i></span><span class="val">{{ sVal.time }}</span> <span class="icon_wrapper" *ngIf="sVal.room"><i class="icon-map-pin"></i></span><span class="val" *ngIf="sVal.room">{{ sVal.room }}</span>
														</div>
													</div>
												</a>
											</div>
											<ul class="tags tags-schedule" *ngIf="'event' == scheduleType">
												<li class="btn btn-default tag-list-{{ tagVal.id }} {{ tagVal.selected == true ? 'activated' : ''}}" *ngFor="let tagVal of sVal.tags" (click)="filterMore( $event, 'tags', tagVal.id, tagVal.name )" attr.data-tag="{{ tagVal.id }}">{{ tagVal.name }}</li>
												<li class="btn btn-default session-event {{ showSelectedsession == true ? 'activated' : '' }}" *ngIf="sVal?.eventType" (click)="filterMore( $event, 'session', sVal.eventTypeId, sVal.eventType )">#{{ sVal.eventType }}</li>
												<li class="btn btn-default gold-btn {{ showSelectedgold == true ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', 5000, 'goldstandard' )" *ngIf="sVal.isGoldStar == true"><i class="icon-star"></i> goldstandard</li>
												<li class="btn btn-default btn-open-session {{ showOpensession == true ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', 25000, 'opensession' )" *ngIf="sVal.isOpenSession == true"><i class="icon-open-session"></i> Open Session</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center load-more link-wrapper" *ngIf="!loadMoreButton && showMoreButton">
			<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more" (click)="loadMoreResultList( offset )" id="show-more-button"><b>Show More</b> <span><i class="icon-breadcrumb-bottom"></i></span></a>
		</div>
	</div>
	<div class="text-center load-more link-wrapper" *ngIf="filterButton">
		<span><span class="loading__circle loading__circle-small"></span></span>
	</div>
</section>
<div class="page-loader text-center load-more link-wrapper" *ngIf="loadMoreButton">
	<span><span class="loading__circle loading__circle-small"></span></span>
</div>